import {useAppContext} from 'contexts/ApplicationContext';
import {useMemo} from 'react';
import {PDFMenu} from 'hooks/Job/PDF';
import {pdfOptionsOrder} from 'shared/helpers';
import {useJobContext} from 'contexts/JobContext';
import {PartialJob} from 'shared/types/PartialJob';
import {PdfType, usePdfLoadingPrompt} from 'shared/helpers/usePdfLoadingPrompt';

export type PDFOption = {
    name: string;
    show: boolean;
    order: number;
    link?: string;
    onClick?: () => void;
};

export const usePDFLinks = () => {
    const {userProfile} = useAppContext();
    const {job} = useJobContext() as PartialJob;
    // NOTE: Prolly change usage of confirmationDialog hook to dialog context later
    // so that we don't have to pass around pdfDialog everytime we need to use this.
    const {viewPdf: viewRoomPlannerPdf, pdfDialog} = usePdfLoadingPrompt(
        PdfType.ROOM_PLANNER,
        false
    );

    const pdfDropDown = useMemo(() => {
        // TODO: Populate these options from `job`.`pdf_attachments` ...
        const dropdown: PDFOption[] = [
            {
                name: PDFMenu.JOB_DETAILS_PDF,
                show:
                    userProfile.hasOwnProperty('showJobPropertiesTablePdf') &&
                    userProfile.showJobPropertiesTablePdf
                        ? true
                        : false,
                order: pdfOptionsOrder(
                    PDFMenu,
                    PDFMenu.JOB_DETAILS_PDF,
                    userProfile
                ),
                link: `/v2/pdf/preview/${job.id}`,
            },
            {
                name: PDFMenu.ORDER_ACKNOWLEDGEMENT_PDF,
                show:
                    userProfile.hasOwnProperty('showOrderAcknowledgementPdf') &&
                    userProfile.showOrderAcknowledgementPdf
                        ? true
                        : false,
                link: `/quotePdf.php?jobId=${job.id}`,
                order: pdfOptionsOrder(
                    PDFMenu,
                    PDFMenu.ORDER_ACKNOWLEDGEMENT_PDF,
                    userProfile
                ),
            },
            {
                name: PDFMenu.JOB_TOPDOWN_LAYOUT_PDF,
                show:
                    !userProfile?.allow3DRoomPlanner &&
                    userProfile?.isTDLDAvailable == 1 &&
                    job.hasOwnProperty('MaxLayoutStatus') &&
                    job.MaxLayoutStatus >= 2,
                link: `/jobTopDownLayoutPDF.php?jobId=${job.id}`,
                order: 4,
            },
        ];

        job?.pdf_attachments?.forEach((attachment) => {
            if (attachment.type === 'room_planner_room_details_pdf') {
                dropdown.push({
                    name: attachment.name,
                    show: userProfile?.allow3DRoomPlanner,
                    order: 5,
                    onClick: () => viewRoomPlannerPdf(attachment.room_id),
                });
            }
        });

        return dropdown;
    }, [job, userProfile]);

    return {
        pdfDialog,
        pdfDropDown,
    };
};
